// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum AddressMode {
  Unspecified = 0,
  Bank = 1,
  CarFromIndex = 2,
  CarFromMessage = 3,
  CarFromField = 4,
  PerCar = 5,
}
